import React from "react";
import { ConditionWrapper, PropertyWrapper } from "./Cards.styled";
import { getConditionValue } from "../../utils";
import { FiArrowRight } from "react-icons/fi";
import { CardTraderConditionValueType } from "magic-shared-types";

interface ConditionProps {
  condition: CardTraderConditionValueType;
  originalCondition?: CardTraderConditionValueType;
}

export const Condition = ({ condition, originalCondition }: ConditionProps) => {
  const conditionValue = getConditionValue(condition);
  const originalConditionValue =
    originalCondition && getConditionValue(originalCondition);

  return (
    <PropertyWrapper>
      {originalConditionValue &&
        originalCondition &&
        originalCondition !== condition && (
          <>
            <ConditionWrapper
              css={{
                background: originalConditionValue?.color,
                color: "red",
                textDecoration: "line-through",
              }}
            >
              {originalConditionValue?.code}
            </ConditionWrapper>
            <FiArrowRight size={18} />
          </>
        )}
      <ConditionWrapper
        css={{
          background: conditionValue?.color,
          padding: "5px 10px",
        }}
      >
        {conditionValue?.code}
      </ConditionWrapper>
    </PropertyWrapper>
  );
};
